"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SidebarComponent_1 = __importDefault(require("../../components/sidebar/SidebarComponent"));
const renderSvgSprite_1 = require("../../render/renderSvgSprite");
const ScreenState_1 = require("../../types/ScreenState");
const notInitialized_1 = require("../../utils/notInitialized");
const note_sprite_svg_1 = __importDefault(require("../../resources/svg/note.sprite.svg"));
const play_sprite_svg_1 = __importDefault(require("../../resources/svg/play.sprite.svg"));
const SidebarButtonPresenter_1 = __importDefault(require("./SidebarButtonPresenter"));
const tracks_1 = require("../../api/tracks");
const ModelStatus_1 = require("../../types/ModelStatus");
const TracksType_1 = require("../../types/TracksType");
const SidebarButtonType_1 = require("../../types/SidebarButtonType");
const SearchPresenter_1 = __importDefault(require("../header/SearchPresenter"));
class SidebarPresenter {
    constructor(parentElement, playlistsModel, tracksModel) {
        this.parentElement = parentElement;
        this.playlistsModel = playlistsModel;
        this.tracksModel = tracksModel;
        this.loadTracksCallback = notInitialized_1.notInitialized;
        this.changeToPlaylist = notInitialized_1.notInitialized;
        this.searchChangeCallback = notInitialized_1.notInitialized;
        this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
        this.sidebarComponent = new SidebarComponent_1.default(playlistsModel);
        this.searchPresenter = this.render();
    }
    render() {
        this.sidebarComponent.removeElement();
        const sidebarElement = this.sidebarComponent.getElement();
        this.parentElement.prepend(sidebarElement);
        const listElement = sidebarElement.querySelector('.aside__list');
        if (!listElement) {
            throw new Error('Element with class .aside__list not found');
        }
        this.addTracksButton(listElement);
        this.addPlaylistListButton(listElement);
        this.addFavoriteButton(listElement);
        for (const playlistData of this.playlistsModel.playlists) {
            this.addPlaylistButton(listElement, playlistData.id);
        }
        this.searchPresenter = this.createSearchPresenter();
        return this.searchPresenter;
    }
    addTracksButton(listElement) {
        const isActive = this.activeButton === SidebarButtonType_1.SidebarButtonType.Tracks &&
            this.tracksModel.tracksType === TracksType_1.TracksType.Tracks;
        new SidebarButtonPresenter_1.default(listElement, 'Треки', () => {
            this.tracksModel.tracksTitle = 'Треки';
            this.tracksModel.tracksType = TracksType_1.TracksType.Tracks;
            this.loadTracksCallback();
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
            this.render();
        }, isActive, (0, renderSvgSprite_1.renderSvgSprite)(note_sprite_svg_1.default.url, 'aside__btn-note-icon'));
    }
    addPlaylistListButton(listElement) {
        new SidebarButtonPresenter_1.default(listElement, 'Плейлисты', () => {
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
            this.tracksModel.onChange(ScreenState_1.ScreenState.Playlists);
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Playlists;
            this.render();
        }, this.activeButton === SidebarButtonType_1.SidebarButtonType.Playlists, (0, renderSvgSprite_1.renderSvgSprite)(play_sprite_svg_1.default.url, 'aside__btn-play-icon'));
    }
    addFavoriteButton(listElement) {
        const isActive = this.activeButton === SidebarButtonType_1.SidebarButtonType.Tracks &&
            this.tracksModel.tracksType === TracksType_1.TracksType.Favorite;
        new SidebarButtonPresenter_1.default(listElement, 'Любимые песни', async () => {
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
            this.tracksModel.tracksTitle = 'Любимые песни';
            this.tracksModel.tracksType = TracksType_1.TracksType.Favorite;
            this.tracksModel.playlistId = null;
            this.tracksModel.status = ModelStatus_1.ModelStatus.Pending;
            this.tracksModel.onChange(ScreenState_1.ScreenState.Tracks);
            this.tracksModel.setAll(await (0, tracks_1.loadFavorites)());
            this.tracksModel.status = ModelStatus_1.ModelStatus.Success;
            this.tracksModel.onChange(ScreenState_1.ScreenState.Tracks);
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
            this.render();
        }, isActive);
    }
    addPlaylistButton(listElement, playlistId) {
        const playlistData = this.playlistsModel.get(playlistId);
        const isActive = this.activeButton === SidebarButtonType_1.SidebarButtonType.Tracks &&
            this.tracksModel.tracksType === TracksType_1.TracksType.Playlist &&
            this.tracksModel.playlistId === playlistData.id;
        new SidebarButtonPresenter_1.default(listElement, playlistData.name, () => {
            const playlistData = this.playlistsModel.get(playlistId);
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
            this.changeToPlaylist(playlistData);
            this.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
            this.render();
        }, isActive);
    }
    createSearchPresenter() {
        const parentElement = this.sidebarComponent
            .getElement()
            .querySelector('.aside__search-container');
        if (!parentElement) {
            throw new Error('nav element is not found');
        }
        const searchPresenter = new SearchPresenter_1.default(parentElement, this.tracksModel, '', 'aside__search round-input', 'Что будем искать?', 'mobile-search');
        searchPresenter.searchChangeCallback = this.searchChangeCallback;
        return searchPresenter;
    }
}
exports.default = SidebarPresenter;
